import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=f05ede1e&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=f05ede1e&prod&lang=scss"
import style1 from "./cooperation.vue?vue&type=style&index=1&id=f05ede1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ede1e",
  null
  
)

export default component.exports